import name from './name'

const selectSliceData = state => state[name]

const selectTitle = state => selectSliceData(state).title

export {
  selectTitle
}
